import type { IconSvgObject } from './types';

const TestTubeDiagonalIcon: IconSvgObject = [
  ["path", { d: "M14.5 2.5L21.5 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20.5 8.5L8.5355 20.4645C7.87246 21.1275 6.97319 21.5 6.0355 21.5C4.08288 21.5 2.49997 19.9171 2.49997 17.9645C2.49997 17.0268 2.87246 16.1275 3.5355 15.4645L15.5 3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6.5 12.5H16.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default TestTubeDiagonalIcon;
